import React, { useEffect, useState } from "react";

import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Button, Checkbox, FormControlLabel, Stack } from "@mui/material";
import { PopoverContentProps } from "components/AiData/PopoverContent";
import { InvestorAutocomplete } from "components/Autocompletes/InvestorAutocomplete";
import { CreateNewInvestorDrawer } from "components/deal/Investors/Create-new-investor-drawer/CreateNewInvestorDrawer";
import { useActionHook } from "hooks";
import { isArray } from "lodash";
import { useDealActions } from "store";

export const InvestorPopoverContent: React.FC<PopoverContentProps> = ({
  openedCell,
  setOpenedCell,
  onChangeSpecificRecommendationValue
}) => {
  const { getDealInvestors } = useDealActions();
  const [dealInvestors, setDealInvestors] = useState<{ id: number; name: string }[]>([]);
  const [investor, setInvestor] = useState<{ id: number; name: string } | null>(
    openedCell?.data.parameter.investor || null
  );
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [split, setSplit] = useState<boolean>(false);

  const { loading: investorsLoading, action } = useActionHook(
    () => openedCell?.data.dealId && getDealInvestors({ dealId: openedCell?.data.dealId }),
    {
      onSuccess: (data) => {
        const investors = isArray(data) ? data.map((item) => ({ id: item.id, name: item.name })) : [];
        setDealInvestors(investors);
      }
    }
  );

  const handleInvestorSelect = ({ id, name }: { id: number; name: string }) => {
    setInvestor({ id, name });
    setIsDrawerOpen(false);
  };

  useEffect(() => {
    action();
  }, []);

  return (
    <>
      <InvestorAutocomplete
        loading={investorsLoading}
        dealInvestors={dealInvestors}
        preselectedInvestorId={investor?.id || null}
        onChange={(value) => setInvestor(value)}
      />

      {!openedCell?.data.is_global_value && dealInvestors.length > 1 && (
        <FormControlLabel
          control={
            <Checkbox
              checked={split}
              checkedIcon={<CheckBoxIcon sx={{ fill: "#071F35" }} />}
              onChange={() => setSplit((prev) => !prev)}
            />
          }
          label="Split by investor commitment"
        />
      )}

      <CreateNewInvestorDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        saveNewInvestorToSelected={(response) => {
          handleInvestorSelect({ id: response.id, name: response.name });
        }}
      />

      <Stack sx={{ flexDirection: "row", justifyContent: "flex-end", gap: "10px" }}>
        <Button
          variant="outlined"
          onClick={() => {
            setOpenedCell(null);
            setInvestor(null);
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={async () => {
            if (openedCell?.data) {
              openedCell.data.parameter.id &&
                (await onChangeSpecificRecommendationValue({
                  id: openedCell.data.parameter.id,
                  field: "investor",
                  value: {
                    id: investor?.id || null,
                    ...(split && { split_by_commitments: split })
                  }
                }));
            }
            setOpenedCell(null);
          }}
          variant="contained"
        >
          Apply
        </Button>
      </Stack>
    </>
  );
};
